import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/Index";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/404/Page404"
    },
    {
      path: "/",
      redirect: "/Index",
      component: Index,
      meta : {keepAlive:false,title: "主页" }
    },
    {
      path: "/Index",
      name: "index",
      component: Index,
      meta : {keepAlive:false,title: "主页" }
    },
    {
      path: "/data",
      name: "data",
      component: () => import("../components/Index-echartsMap"),
      meta : {keepAlive:false,title: "主页2" }
    },
    {
      path: '/usefInfo',
      name: 'usefInfo',
      component: () => import("../components/user/userInfo"),
      meta : {keepAlive:false,title: "用户信息"}
    },
 {
      path: '/User',
      name: 'User',
      component: () => import("../components/user/User"),
      meta : {keepAlive:true,title: "用户列表"}
    },
    {
      path: '/UserAdd',
      name: 'UserAdd',
      component: () => import("../components/user/UserAdd"),
      meta : {keepAlive:false,title: "用户新增"}
    },

    {
      path: '/UserEdit',
      name: 'UserEdit',
      component: () => import("../components/user/UserEdit"),
      meta : {keepAlive:false,title: "用户列表"}
    },
    //permission
    {
      path: '/Permission',
      name: 'Permission',
      component: () => import("../components/permission/Permission"),
      meta : {keepAlive:false,title: "权限"}
    },   {
      path: '/PermissionAdd',
      name: 'PermissionAdd',
      component: () => import("../components/permission/PermissionAdd"),
      meta : {keepAlive:false,title: "权限新增"}
    },   {
      path: '/PermissionEdit',
      name: 'PermissionEdit',
      component: () => import("../components/permission/PermissionEdit"),
      meta : {keepAlive:false,title: "权限编辑"}
    },   {
      path: '/PermissionGroup',
      name: 'PermissionGroup',
      component: () => import("../components/permission/PermissionGroup"),
      meta : {keepAlive:false,title: "权限组"}
    },   {
      path: '/PermissionGroupAdd',
      name: 'PermissionGroupAdd',
      component: () => import("../components/permission/PermissionGroupAdd"),
      meta : {keepAlive:false,title: "权限组新增"}
    },   {
      path: '/PermissionGroupEdit',
      name: 'PermissionGroupEdit',
      component: () => import("../components/permission/PermissionGroupEdit"),
      meta : {keepAlive:false,title: "权限组编辑"}
    },



    {
      path: "/monmap",
      name: "monmap",
      component: () => import("../components/404/monmap"),
      meta : {keepAlive:false,title: "监控对象地图" }
    },
    {
      path: "/devmap",
      name: "devmap",
      component: () => import("../components/404/devmap"),
      meta : {keepAlive:false,title: "设备地图" }
    },
    {
      path: "/map",
      name: "map",
      component: () => import("../components/404/map"),
      meta : {keepAlive:false,title: "地图" }
    },
    // 404
    {
      path: "/404/Page404",
      name: "Page404",
      component: () => import("../components/404/Page404"),
      meta : {keepAlive:false,title: "页面丢失" }
    },
    // 公司管理
    {
      path: "/companybundle/index",
      name: "index",
      component: () => import("../components/companybundle/index"),
      meta : {keepAlive:false,title: "公司基本信息" }
    },
    {
      path: "/companybundle/noplatuser",
      name: "noplatuser",
      component: () => import("../components/companybundle/noplatuser"),
      meta : {keepAlive:false,title: "部门人员管理" }
    },
    {
      path: "/companybundle/platuser",
      name: "platuser",
      component: () => import("../components/companybundle/platuser"),
      meta : {keepAlive:false,title: "联系人" }
    },
    {
      path: "/company/Company",
      name: "Company",
      component: () => import("../components/company/Company"),
      meta : {keepAlive:false,title: "公司管理" }
    },

    //Company
    {
      path: '/companyAdmin/Company',
      name: 'Company',
      component: () => import('../components/companyAdmin/Company.vue'),
      meta: {
        title: '公司列表',
        name: '公司列表',
      }
    },
    {
      path: '/companyAdmin/CompanyAdd',
      name: 'CompanyAdd',
      component: () => import('../components/companyAdmin/CompanyAdd.vue'),
      meta: {
        title: '公司添加',
        name: '公司添加',
        array: [{name: '公司列表', path: '/Company'}, {name: '公司列表', path: '/CompanyAdd'}]
      }
    },
    {
      path: '/companyAdmin/CompanyEdit',
      name: 'CompanyEdit',
      component: () => import('../components/companyAdmin/CompanyEdit.vue'),
      meta: {
        title: '公司编辑',
        name: '公司编辑',
        array: [{name: '公司列表', path: '/Company'}, {name: '公司编辑', path: '/CompanyEdit'}]
      }
    },
    {
      path: '/companyAdmin/DeptList',
      name: 'DeptList',
      component: () => import('../components/companyAdmin/DeptList.vue'),
      meta: {
        title: '部门列表',
        name: '部门列表',
      }
    },



    {
      path: "/company/CreateCompany",
      name: "CreateCompany",
      component: () => import("../components/company/CreateCompany"),
      meta : {keepAlive:false,title: "创建公司" }
    },
    {
      path: "/company/TransferCompany",
      name: "TransferCompany",
      component: () => import("../components/company/TransferCompany"),
      meta : {keepAlive:false,title: "转让公司" }
    },



    {
      path: "/company/NoPlatformUser",
      name: "NoPlatformUser",
      component: () => import("../components/company/NoPlatformUser"),
      meta : {keepAlive:false,title: "联系人管理" }
    },
    {
      path: "/company/Departmentuser",
      name: "Departmentuser",
      component: () => import("../components/company/Departmentuser"),
      meta : {keepAlive:false,title: "部门人员管理" }
    },
    // 日志中心
    {
      path: "/log/Userlog",
      name: "Userlog",
      component: () => import("../components/log/Userlog"),
      meta : {keepAlive:false,title: "用户日志" }
    },
    {
      path: "/log/MonitorobjectLog",
      name: "MonitorobjectLog",
      component: () => import("../components/log/MonitorobjectLog"),
      meta : {keepAlive:false,title: "监控对象日志" }
    },
    {
      path: "/log/Devlog",
      name: "Devlog",
      component: () => import("../components/log/Devlog"),
      meta : {keepAlive:false,title: "设备日志" }
    },
    // 报警管理
    {
      path: "/alarm/Rule",
      name: "Rule",
      component: () => import("../components/alarm/Rule"),
      meta : {keepAlive:false,title: "报警规则" }
    },
    {
      path: "/alarm/RuleAdd",
      name: "RuleAdd",
      component: () => import("../components/alarm/RuleAdd"),
      meta : {keepAlive:false,title: "报警规则添加" }
    },
    {
      path: "/alarm/RuleDetial",
      name: "RuleDetial",
      component: () => import("../components/alarm/RuleDetial"),
      meta : {keepAlive:false,title: "报警规则详情" }
    },
    {
      path: "/alarm/RuleBind",
      name: "RuleBind",
      component: () => import("../components/alarm/RuleBind"),
      meta : {keepAlive:false,title: "报警规则绑定" }
    },
    {
      path: "/alarm/RuleEdit",
      name: "RuleEdit",
      component: () => import("../components/alarm/RuleEdit"),
      meta : {keepAlive:false,title: "报警规则编辑" }
    },
    {
      path: "/alarm/Rulelog",
      name: "Rulelog",
      component: () => import("../components/alarm/Rulelog"),
      meta : {keepAlive:false,title: "报警记录" }
    },

    //设备
    {
      path: "/dev/DevView",
      name: "DevView",
      component: () => import("../components/dev/DevView"),
      meta : {keepAlive:false,title: "设备视图" }
    },

    {
      path: "/dev/DevList",
      name: "DevList",
      component: () => import("../components/dev/DevList"),
      meta : {keepAlive:false,title: "设备列表" }
    },
    {
      path: "/dev/DevStop",
      name: "DevStop",
      component: () => import("../components/dev/DevStop"),
      meta: { title: "设备报停" }
    }, {
      path: "/dev/DevStart",
      name: "DevStart",
      component: () => import("../components/dev/DevStart"),
      meta: { title: "设备启用" }
    },
    {
      path: "/dev/DevAdd",
      name: "DevAdd",
      component: () => import("../components/dev/DevAdd"),
      meta : {keepAlive:false,title: "设备新增" }
    },
    {
      path: "/dev/DevEdit",
      name: "DevEdit",
      component: () => import("../components/dev/DevEdit"),
      meta : {keepAlive:false,title: "设备编辑" }
    },  {
      path: "/dev/ListDevBelongToAccount",
      name: "ListDevBelongToAccount",
      component: () => import("../components/dev/ListDevBelongToAccount"),
      meta : {keepAlive:false,title: "设备与用户" }
    },
    {
      path: "/dev/DevHistoryData",
      name: "DevHistoryData",
      component: () => import("../components/dev/DevHistoryData"),
      meta : {keepAlive:false,title: "设备历史数据" }
    },
    {
      path: "/dev/DevHistoryDataTwo",
      name: "DevHistoryDataTwo",
      component: () => import("../components/dev/DevHistoryDataTwo"),
      meta : {keepAlive:false,title: "设备历史数据(二版)" }
    },
    {
      path: "/dev/DevHistoryDataOver",
      name: "DevHistoryDataOver",
      component: () => import("../components/dev/DevHistoryDataOver"),
      meta : {keepAlive:false,title: "设备超标数据" }
    },
    {
      path: "/dev/DevHistoryDataOverTwo",
      name: "DevHistoryDataOverTwo",
      component: () => import("../components/dev/DevHistoryDataOverTwo"),
      meta : {keepAlive:false,title: "设备超标数据(二版)" }
    },
      {
          path: "/dev/DevEditCards",
          name: "DevEditCards",
          component: () => import("../components/dev/DevEditCards"),
          meta: { title: "设备编辑卡片" }
      },
    {
      path: "/dev/DataHandle",
      name: "DataHandle",
      component: () => import("../components/dev/DataHandle"),
      meta : {keepAlive:false,title: "超标事务处理" }
    },
    {
      path: "/dev/DataHandleDetial",
      name: "DataHandleDetial",
      component: () => import("../components/dev/DataHandleDetial"),
      meta : {keepAlive:false,title: "超标处理详情" }
    },
    {
      path: "/dev/DataOverHandle",
      name: "DataOverHandle",
      component: () => import("../components/dev/DataOverHandle"),
      meta : {keepAlive:false,title: "超标处理" }
    },
    {
      path: "/dev/DevCurve",
      name: "DevCurve",
      component: () => import("../components/dev/DevCurve"),
      meta : {keepAlive:false,title: "历史曲线" }
    },
    {
      path: "/dev/DevPdf",
      name: "DevPdf",
      component: () => import("../components/dev/DevPdf"),
      meta : {keepAlive:false,title: "历史曲线打印" }
    },
    {
      path: "/dev/DevCurveTwo",
      name: "DevCurveTwo",
      component: () => import("../components/dev/DevCurveTwo"),
      meta : {keepAlive:false,title: "历史曲线(二版)" }
    },
    {
      path: "/dev/DevLocation",
      name: "DevLocation",
      component: () => import("../components/dev/DevLocation"),
      meta : {keepAlive:false,title: "定位" }
    },
    {
      path: "/dev/DevLocationPlayBack",
      name: "DevLocationPlayBack",
      component: () => import("../components/dev/DevLocationPlayBack"),
      meta : {keepAlive:false,title: "定位回放" }
    },
    //监控对象
    {
      path: "/monitor/MonitorView",
      name: "MonitorView",
      component: () => import("../components/monitor/MonitorView"),
      meta : {keepAlive:false,title: "监控对象视图" }
    },
    {
      path: "/monitor/MonitorList",
      name: "MonitorList",
      component: () => import("../components/monitor/MonitorList"),
      meta : {keepAlive:false,title: "监控对象列表" }
    },
    {
      path: "/monitor/MaintenanceRecord",
      name: "MaintenanceRecord",
      component: () => import("../components/monitor/MaintenanceRecord"),
      meta : {keepAlive:false,title: "维修记录" }
    },
    {
      path: "/monitor/MaintenanceRecordAdd",
      name: "MaintenanceRecordAdd",
      component: () => import("../components/monitor/MaintenanceRecordAdd"),
      meta : {keepAlive:false,title: "维修记录新增" }
    },
    {
      path: "/monitor/MonitorUser",
      name: "MonitorUser",
      component: () => import("../components/monitor/MonitorUser"),
      meta : {keepAlive:false,title: "分配对象" }
    },
    {
      path: "/monitor/MonitorRebind",
      name: "MonitorRebind",
      component: () => import("../components/monitor/MonitorRebind"),
      meta : {keepAlive:false,title: "重新关联" }
    },
    {
      path: "/monitor/MonitorDistribute",
      name: "MonitorDistribute",
      component: () => import("../components/monitor/MonitorDistribute"),
      meta : {keepAlive:false,title: "分配对象 - 分配" }
    },
    {
      path: "/monitor/MonitorHistoryData",
      name: "MonitorHistoryData",
      component: () => import("../components/monitor/MonitorHistoryData"),
      meta : {keepAlive:false,title: "监控对象历史数据" }
    },
    {
      path: "/monitor/MonitorHistoryDataOver",
      name: "MonitorHistoryDataOver",
      component: () => import("../components/monitor/MonitorHistoryDataOver"),
      meta : {keepAlive:false,title: "监控对象超标数据" }
    },
    {
      path: "/monitor/MonitorCurve",
      name: "MonitorCurve",
      component: () => import("../components/monitor/MonitorCurve"),
      meta : {keepAlive:false,title: "监控对象历史曲线" }
    },
    {
      path: "/monitor/MonitorAdd",
      name: "MonitorAdd",
      component: () => import("../components/monitor/MonitorAdd"),
      meta : {keepAlive:false,title: "监控对象新增" }
    },
    {
      path: "/monitor/MonitorEdit",
      name: "MonitorEdit",
      component: () => import("../components/monitor/MonitorEdit"),
      meta : {keepAlive:false,title: "监控对象编辑" }
    },
    {
      path: "/monitor/DragMap",
      name: "DragMap",
      component: () => import("../components/monitor/DragMap"),
      meta : {keepAlive:false,title: "布点图" }
    },
    {
      path: "/monitor/DragDetial",
      name: "DragDetial",
      component: () => import("../components/monitor/DragDetial"),
      meta : {keepAlive:false,title: "布点图详情" }
    },
    {
      path: "/monitor/MonitorDataOverHandle",
      name: "MonitorDataOverHandle",
      component: () => import("../components/monitor/MonitorDataOverHandle"),
      meta: { title: "超标处理" }
    }, {
      path: "/monitor/DataHandleDetial",
      name: "DataHandleDetial",
      component: () => import("../components/monitor/DataHandleDetial"),
      meta: { title: "超标处理查看" }
    }, {
      path: "/monitor/DataHandle",
      name: "DataHandle",
      component: () => import("../components/monitor/DataHandle"),
      meta: { title: "超标事务处理" }
    },
    //消息 公告
    {
      path: "/msg/Notice",
      name: "Notice",
      component: () => import("../components/msg/Notice"),
      meta : {keepAlive:false,title: "公告" }
    },
    {
      path: "/msg/Msg",
      name: "Msg",
      component: () => import("../components/msg/Msg"),
      meta : {keepAlive:false,title: "消息" }
    },
    //物流
    {
      path: "/logistical/LogisticalList",
      name: "LogisticalList",
      component: () => import("../components/logistical/LogisticalList"),
      meta : {keepAlive:false,title: "运单列表" }
    },
    {
      path: "/logistical/LogisticalAdd",
      name: "LogisticalAdd",
      component: () => import("../components/logistical/LogisticalAdd"),
      meta : {keepAlive:false,title: "运单新增" }
    },
    {
      path: "/logistical/LogisticalEdit",
      name: "LogisticalEdit",
      component: () => import("../components/logistical/LogisticalEdit"),
      meta : {keepAlive:false,title: "运单编辑" }
    },
    {
      path: "/logistical/LogisticalFind",
      name: "LogisticalFind",
      component: () => import("../components/logistical/LogisticalFind"),
      meta : {keepAlive:false,title: "运单查询" }
    },
    {
      path: "/logistical/LogisticalFindInfo",
      name: "LogisticalFindInfo",
      component: () => import("../components/logistical/LogisticalFindInfo"),
      meta : {keepAlive:false,title: "运单详情" }
    },

    {
      path: "/print/DevPdf",
      name: "DevPdf",
      component: () => import("../components/print/DevPdf"),
      meta : {keepAlive:false,title: "设备数据打印" }
    },
    {
      path: "/DevViewAll",
      name: "DevViewAll",
      component: () => import("../components/dev/DevViewAll"),
      meta : {keepAlive:false,title: "设备视图" }
    },
    {
      path: "/DevViewAll18",
      name: "DevViewAll18",
      component: () => import("../components/dev/DevViewAll18"),
      meta : {keepAlive:false,title: "设备视图" }
    },

    {
      path: '/GetDevData',
      name: 'GetDevData',
      component: () => import("../components/api/GetDevData"),
      meta: {
        title: "获取设备历史数据接口",
        name: "获取设备历史数据接口",
      }
    },
    {
      path: '/ListDevStatusBySN',
      name: 'ListDevStatusBySN',
      component: () => import("../components/api/ListDevStatusBySN"),
      meta: {
        title: "获取设备实时状态接口",
        name: "获取设备实时状态接口",
      }
    },
    {
      path: '/GetDevList',
      name: 'GetDevList',
      component: () => import("../components/api/GetDevList"),
      meta: {
        title: "获取设备列表接口",
        name: "获取设备列表接口",
      }
    },
    {
      path: '/Devalarm',
      name: 'Devalarm',
      component: () => import('../components/equipment/Devalarm.vue'),
      meta: {
        title: '声光报警设备',
        name: '声光报警设备',
      }
    },
    {
      path: '/DevalarmAdd',
      name: 'DevalarmAdd',
      component: () => import('../components/equipment/DevalarmAdd.vue'),
      meta: {
        title: '声光报警设备添加',
        name: '声光报警设备添加',
      }
    },
    {
      path: '/DevalarmEdit',
      name: 'DevalarmEdit',
      component: () => import('../components/equipment/DevalarmEdit.vue'),
      meta: {
        title: '声光报警设备编辑',
        name: '声光报警设备编辑',
      }
    },

    //广西对接

    {
      path: "/unitList",
      name: "unitList",
      component: () => import("../components/unit/unit"),
      meta: { title: "单位列表", name: "单位列表" },
    },
    {
      path: "/unitAdd",
      name: "unitAdd",
      component: () => import("../components/unit/unitAdd.vue"),
      meta: {
        title: "单位添加",
        name: "单位添加",
        array: [
          { name: "单位列表", path: "/unitList" },
          { name: "单位添加", path: "/unitAdd" },
        ],
      },
    },
    {
      path: "/unitEdit",
      name: "unitEdit",
      component: () => import("../components/unit/unitEdit.vue"),
      meta: {
        title: "单位编辑",
        name: "单位编辑",
        array: [
          { name: "单位列表", path: "/unitList" },
          { name: "单位编辑", path: "/unitEdit" },
        ],
      },
    },
    {
      path: "/equipmentList",
      name: "equipmentList",
      component: () => import("../components/equipment/equipment"),
      meta: { title: "冷链设备", name: "冷链设备" },
    },
    {
      path: "/devList",
      name: "devList",
      component: () => import("../components/abutmentDev/dev"),
      meta: { title: "设备列表", name: "设备列表" },
    },
    {
      path: "/abutmentDev/devAdd",
      name: "abutmentDevAdd",
      component: () => import("../components/abutmentDev/devAdd.vue"),
      meta: {
        title: "设备添加",
        name: "设备添加",

      },
    },
    {
      path: "/abutmentDev/devEdit",
      name: "abutmentDevEdit",
      component: () => import("../components/abutmentDev/devEdit.vue"),
      meta: {
        title: "设备编辑",
        name: "设备编辑",
      },
    },
    {
      path: "/history/historyList",
      name: "historyList",
      component: () => import("../components/history/historyList.vue"),
      meta: {
        title: "历史记录查询",
        name: "历史记录查询",
      },
    },
    //广西对接



    {
      path: "/login",
      name: "login",
      component: () => import("../components/login/login"),
      meta : {keepAlive:false,title: "login" }
    },
    {
      path: "/agree",
      name: "agree",
      component: () => import("../components/login/agree"),
      meta : {keepAlive:false,title: "agree" }
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js